import { Auth } from "./auth.js";
import { escapeHtml } from "./utils.js";
import { ensureMappingsLoaded } from "./orders_render.js";

/**
 * Efast Workbench - 产品中心 + 类目管理
 * 从 sales_logic.js 拆分
 */

window._categoryCache = [];
window._editModel = null;

/**
 * ==========================================
 * 11. 产品中心
 * ==========================================
 */
let _productCache = [];

function initProductCenter() {
    ensureMappingsLoaded().then(function() { loadProducts(); });
    loadCategoryFilter();
}

async function loadProducts() {
    var container = document.getElementById('product-card-list');
    if (!container) return;
    try {
        var data = await Auth.apiFetch('/api/products');
        _productCache = data.products;
        renderProductTable(_productCache);
    } catch (e) {
        container.innerHTML = '<div style="text-align:center;color:#ef4444;padding:60px;">加载失败: ' + escapeHtml(e.message) + '</div>';
    }
}

// 获取产品型号对应的阿里映射链接（右侧数字超链接）
function getModelLinksHTML(model) {
    if (!model || !_mappingCache || !_mappingCache.length) return "";
    var urls = _mappingCache.filter(function(m) { return m.erpModel && m.erpModel.toUpperCase() === model.toUpperCase(); });
    if (!urls.length) return "";
    return '<span class="product-links-group">' + urls.map(function(m, i) {
        var shortId = m.aliUrl.match(/\d{10,}/);
        var label = shortId ? shortId[0].slice(-6) : (i + 1);
        return '<a href="' + escapeHtml(m.aliUrl) + '" target="_blank" class="product-link-num" title="' + escapeHtml(m.aliUrl) + '">[' + (i + 1) + ']</a>';
    }).join(' ') + '</span>';
}

function renderProductTable(list) {
    var container = document.getElementById('product-card-list');
    if (!container) return;
    if (!list.length) { container.innerHTML = '<div style="text-align:center;color:var(--text-muted);padding:60px;">暂无产品数据</div>'; return; }

    container.innerHTML = list.map(function (p) {
        var imgSrc = '/api/product-image/' + encodeURIComponent(p.model);
        var standardPrice = (p.priceTiers && p.priceTiers.length > 0) ? p.priceTiers[0].price.toFixed(2) : '--';

        var priceCols = '';
        for (var i = 0; i < 4; i++) {
            var tier = p.priceTiers && p.priceTiers[i];
            if (tier) {
                priceCols += '<div class="price-col"><div class="tier-qty">' + (typeof tier.qty === 'number' ? tier.qty + 'pcs' : tier.qty) + '</div><div class="tier-price">$' + tier.price.toFixed(2) + ' <span class="price-unit">USD</span></div></div>';
            } else {
                priceCols += '<div class="price-col empty">--</div>';
            }
        }

        return '<div class="product-card" data-model="' + escapeHtml(p.model) + '">' +
            '<div class="product-card-row">' +
                '<img loading="lazy" src="' + imgSrc + '" class="product-card-img" onerror="this.parentElement.insertBefore(createPlaceholder(),this);this.remove()" onclick="window.open(\'' + imgSrc + '\',\'_blank\')">' +
                '<span class="product-card-model">' + escapeHtml(p.model) + '</span>' +
                (p.category ? '<span class="product-card-category">' + escapeHtml(p.category) + '</span>' : '') +
                '<span class="product-card-name" title="' + escapeHtml(p.productName || '') + '">' + escapeHtml(p.productName || '--') + '</span>' +
                priceCols +
                '<div class="product-card-rate" id="rate-' + escapeHtml(p.model) + '"></div>' +
            '</div>' +
            '<div class="product-card-row" style="display:flex;justify-content:space-between;align-items:center;">' +
                '<span class="product-card-desc" title="' + escapeHtml(p.description || '') + '">' + escapeHtml(p.description || '暂无描述') + '</span>' +
                '<span class="product-card-links">' + getModelLinksHTML(p.model) + '</span>' +
            '</div>' +
            '<div class="product-card-row">' +
                fieldHtml('重量(g)', p.weight) +
                fieldHtml('产品尺寸', p.dimensions) +
                fieldHtml('装箱数', p.packingQty) +
                fieldHtml('箱规', p.cartonSize) +
                fieldHtml('每箱重量(kg)', p.cartonWeight) +
            '</div>' +
            '<div class="product-card-row">' +
                fieldHtml('HS Code', p.hsCode) +
                fieldHtml('采购成本', (p.purchaseCost ? '¥' + p.purchaseCost : '')) +
                fieldHtml('备注', (p.remarks || '').replace(/\n/g, ' ')) +
                '<span style="flex:1;"></span>' +
                '<div class="product-card-actions">' +
                    '<button class="btn-product-edit" onclick="showProductForm(\'' + escapeHtml(p.model) + '\')"><i class="fa-solid fa-pen-to-square"></i> 编辑</button>' +
                    '<button class="btn-product-delete" onclick="deleteProduct(\'' + escapeHtml(p.model) + '\')"><i class="fa-solid fa-trash"></i></button>' +
                '</div>' +
            '</div>' +
        '</div>';
    }).join('');
    setTimeout(function() { updateAllProductRateDisplays(); }, 100);
}

function updateAllProductRateDisplays() {
    if (typeof getExchangeRate !== 'function') return;
    var rate = getExchangeRate();
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function(card) {
        var model = card.getAttribute('data-model');
        var el = document.getElementById('rate-' + model);
        if (!el) return;
        var p = _productCache.find(function(x) { return x.model === model; });
        if (!p || !p.priceTiers || !p.priceTiers.length) { el.innerHTML = ''; return; }
        var usdPrice = p.priceTiers[0].price;
        var rmbPrice = (usdPrice * rate).toFixed(2);
        el.innerHTML = '<span class="rate-label">≈ ¥' + rmbPrice + '</span><span class="rate-note"> @ ' + rate.toFixed(4) + '</span>';
    });
}

function createPlaceholder() {
    var div = document.createElement('div');
    div.className = 'product-card-img-placeholder';
    div.innerHTML = '<i class="fa-solid fa-image"></i>';
    return div;
}

function fieldHtml(label, value) {
    var display = value !== undefined && value !== null && value !== '' ? value : '--';
    return '<span class="product-card-field"><span class="field-label">' + label + ':</span> <span class="field-value">' + escapeHtml(display) + '</span></span>';
}

function filterProductTable() {
    var q = (document.getElementById('product-search').value || '').toLowerCase();
    var catEl = document.getElementById('product-category-filter');
    var cat = catEl ? catEl.value : '';
    var filtered = _productCache;
    if (q) {
        filtered = filtered.filter(function (p) {
            return (p.model || '').toLowerCase().indexOf(q) !== -1 ||
                   (p.productName || '').toLowerCase().indexOf(q) !== -1 ||
                   (p.description || '').toLowerCase().indexOf(q) !== -1;
        });
    }
    if (cat) {
        filtered = filtered.filter(function (p) {
            return (p.category || '').trim() === cat;
        });
    }
    renderProductTable(filtered);
}

function startInlineEdit(span, model, field) {}

function saveInlineEdit(input, model, field) {}

function editPriceTiers(model) {
    var p = findCached(model);
    if (!p) return;
    var raw = prompt('编辑阶梯价格 JSON:\n[{"qty":1,"price":3.6},{"qty":200,"price":3.5}]', JSON.stringify(p.priceTiers || []));
    if (raw === null) return;
    try {
        var tiers = JSON.parse(raw);
        Auth.apiFetch('/api/products/' + encodeURIComponent(model), { method: 'PUT', body: JSON.stringify({ priceTiers: tiers }) }).then(function () {
            loadProducts();
        });
    } catch (e) { alert('JSON 格式错误: ' + e.message); }
}

var _editModel = null;
function showProductForm(model) {
    updateProductFormCategorySelect();
    _editModel = model || null;
    var modal = document.getElementById('product-form-modal');
    var title = document.getElementById('product-form-title');
    var errEl = document.getElementById('product-form-error');
    if (!modal) return;
    modal.style.display = 'flex';
    if (errEl) errEl.style.display = 'none';
    clearFormFields();
    if (model) {
        if (title) title.innerHTML = '<i class="fa-solid fa-pen-to-square"></i> 编辑产品: ' + escapeHtml(model);
        var p = findCached(model);
        if (p) fillFormFields(p);
    } else {
        if (title) title.innerHTML = '<i class="fa-solid fa-box"></i> 添加产品';
    }
}

function closeProductForm() {
    var modal = document.getElementById('product-form-modal');
    if (modal) modal.style.display = 'none';
    _editModel = null;
}

function clearFormFields() {
    ['pf-model','pf-name','pf-category','pf-image-name','pf-desc','pf-weight','pf-dims','pf-packingqty','pf-carton-size','pf-carton-weight','pf-hscode','pf-cost','pf-remarks','pf-tiers'].forEach(function (id) {
        var el = document.getElementById(id); if (el) el.value = '';
    });
    var imgEl = document.getElementById('pf-image'); if (imgEl) imgEl.value = '';
    var modelEl = document.getElementById('pf-model'); if (modelEl) modelEl.disabled = false;
}

function fillFormFields(p) {
    document.getElementById('pf-model').value = p.model || '';
    document.getElementById('pf-model').disabled = !!_editModel;
    document.getElementById('pf-name').value = p.productName || '';
    document.getElementById('pf-desc').value = p.description || '';
    document.getElementById('pf-weight').value = p.weight || '';
    document.getElementById('pf-dims').value = p.dimensions || '';
    document.getElementById('pf-packingqty').value = p.packingQty || '';
    document.getElementById('pf-carton-size').value = p.cartonSize || '';
    document.getElementById('pf-carton-weight').value = p.cartonWeight || '';
    document.getElementById('pf-hscode').value = p.hsCode || '';
    var pfCat = document.getElementById('pf-category'); if (pfCat) pfCat.value = p.category || '';
    document.getElementById('pf-image-name').value = p.imageName || '';
    document.getElementById('pf-cost').value = p.purchaseCost || '';
    document.getElementById('pf-remarks').value = p.remarks || '';
    document.getElementById('pf-tiers').value = JSON.stringify(p.priceTiers || []);
}

async function submitProductForm() {
    var model = document.getElementById('pf-model').value.trim();
    var errEl = document.getElementById('product-form-error');
    if (!model) { if (errEl) { errEl.style.display = 'block'; errEl.textContent = '型号为必填'; } return; }
    var body = {
        productName: document.getElementById('pf-name').value.trim(),
        imageName: document.getElementById('pf-image-name').value.trim(),
        category: document.getElementById('pf-category').value.trim(),
        description: document.getElementById('pf-desc').value.trim(),
        weight: document.getElementById('pf-weight').value.trim(),
        dimensions: document.getElementById('pf-dims').value.trim(),
        packingQty: document.getElementById('pf-packingqty').value.trim(),
        cartonSize: document.getElementById('pf-carton-size').value.trim(),
        cartonWeight: document.getElementById('pf-carton-weight').value.trim(),
        hsCode: document.getElementById('pf-hscode').value.trim(),
        purchaseCost: document.getElementById('pf-cost').value.trim(),
        remarks: document.getElementById('pf-remarks').value.trim()
    };
    var tiersRaw = document.getElementById('pf-tiers').value.trim();
    if (tiersRaw) {
        try { body.priceTiers = JSON.parse(tiersRaw); }
        catch (e) { if (errEl) { errEl.style.display = 'block'; errEl.textContent = '阶梯价格 JSON 格式错误'; } return; }
    }
    try {
        if (_editModel) {
            await Auth.apiFetch('/api/products/' + encodeURIComponent(_editModel), { method: 'PUT', body: JSON.stringify(body) });
        } else {
            body.model = model;
            await Auth.apiFetch('/api/products', { method: 'POST', body: JSON.stringify(body) });
        }
        closeProductForm();
        loadProducts();
    } catch (e) {
        if (errEl) { errEl.style.display = 'block'; errEl.textContent = e.message; }
    }
}

async function deleteProduct(model) {
    if (!confirm('确定删除产品 ' + model + ' 吗？')) return;
    try {
        await Auth.apiFetch('/api/products/' + encodeURIComponent(model), { method: 'DELETE' });
        loadProducts();
    } catch (e) { alert('删除失败: ' + e.message); }
}

function findCached(model) {
    for (var i = 0; i < _productCache.length; i++) {
        if (_productCache[i].model === model) return _productCache[i];
    }
    return null;
}

function exportProducts() {
    window.location.href = '/api/products/export-excel?token=' + encodeURIComponent(Auth.getToken());
}

async function importExcel(input) {
    var file = input.files[0];
    if (!file) return;
    if (!confirm('将导入 Excel 文件中的产品，已存在的型号会跳过。确认导入？')) { input.value = ''; return; }
    try {
        var formData = new FormData();
        formData.append('file', file);
        var token = Auth.getToken();
        var res = await fetch('/api/products/import-excel', {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + token },
            body: formData
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.error || '导入失败');
        alert('导入完成！新增 ' + data.added + ' 个，跳过 ' + data.skipped + ' 个（型号已存在）');
        input.value = '';
        loadProducts();
    } catch (e) {
        alert('导入失败: ' + e.message);
        input.value = '';
    }
}


/* ==========================================
 * 类目管理
 * ========================================== */
var _categoryCache = [];

async function loadCategoryFilter() {
    try {
        var data = await Auth.apiFetch('/api/categories');
        // 健壮性处理：兼容新旧返回格式
        _categoryCache = (data && Array.isArray(data.categories)) ? data.categories : (Array.isArray(data) ? data : []);
        
        var sel = document.getElementById('product-category-filter');
        if (sel) {
            var currentVal = sel.value;
            sel.innerHTML = '<option value="">全部类目</option>' +
                _categoryCache.map(function(c) {
                    return '<option value="' + escapeHtml(c.name) + '">' + escapeHtml(c.name) + '</option>';
                }).join('');
            sel.value = currentVal;
        }
        updateProductFormCategorySelect();
    } catch (e) {
        console.error('加载类目失败:', e);
    }
}

function updateProductFormCategorySelect() {
    var pfCat = document.getElementById('pf-category');
    if (!pfCat || pfCat.tagName !== 'SELECT') return;
    var currentVal = pfCat.value;
    
    // 强制类型检查
    const list = Array.isArray(_categoryCache) ? _categoryCache : [];
    
    pfCat.innerHTML = '<option value="">请选择类目</option>' +
        list.map(function(c) {
            return '<option value="' + escapeHtml(c.name) + '">' + escapeHtml(c.name) + '</option>';
        }).join('');
    pfCat.value = currentVal;
}


// ===== 类目管理页面函数 (内嵌编辑模式) =====

async function loadCategoryManagement() {
    var tbody = document.getElementById('category-table-body');
    if (!tbody) return;
    try {
        var data = await Auth.apiFetch('/api/categories');
        _categoryCache = (data && Array.isArray(data.categories)) ? data.categories : (Array.isArray(data) ? data : []);
        
        if (!_categoryCache.length) {
            tbody.innerHTML = '<tr><td colspan="3" style="text-align:center;color:var(--text-muted);">暂无类目，请添加</td></tr>';
            return;
        }
        tbody.innerHTML = _categoryCache.map(function(c) {
            return '<tr data-cat-id="' + c.id + '">' +
                '<td>' + c.id + '</td>' +
                '<td><input type="text" class="cat-inline-input" value="' + escapeHtml(c.name) + '" id="cat-input-' + c.id + '"></td>' +
                '<td>' +
                    '<button class="btn-action btn-sm cat-save-btn" onclick="saveCategoryInline(' + c.id + ')" title="保存"><i class="fa-solid fa-check"></i></button> ' +
                    '<button class="btn-action btn-sm cat-del-btn" onclick="deleteCategory(' + c.id + ')" title="删除"><i class="fa-solid fa-trash"></i></button>' +
                '</td>' +
            '</tr>';
        }).join('');
    setTimeout(function() { updateAllProductRateDisplays(); }, 100);
} catch (e) {
        tbody.innerHTML = '<tr><td colspan="3" style="text-align:center;color:#ef4444;">加载失败: ' + escapeHtml(e.message) + '</td></tr>';
    }
}

async function addCategoryInline() {
    var input = document.getElementById('category-new-input');
    var name = input ? input.value.trim() : '';
    if (!name) return;
    try {
        await Auth.apiFetch('/api/categories', {
            method: 'POST',
            body: JSON.stringify({ name: name })
        });
        if (input) input.value = '';
        loadCategoryManagement();
        loadCategoryFilter();
    } catch (e) {
        alert('添加失败: ' + e.message);
    }
}

async function saveCategoryInline(id) {
    var input = document.getElementById('cat-input-' + id);
    var name = input ? input.value.trim() : '';
    if (!name) { alert('类目名称不能为空'); return; }
    try {
        await Auth.apiFetch('/api/categories/' + id, {
            method: 'PUT',
            body: JSON.stringify({ name: name })
        });
        loadCategoryManagement();
        loadCategoryFilter();
    } catch (e) {
        alert('保存失败: ' + e.message);
    }
}

async function deleteCategory(id) {
    if (!confirm('确定要删除此类目吗？')) return;
    try {
        await Auth.apiFetch('/api/categories/' + id, { method: 'DELETE' });
    } catch (e) {
        alert('删除失败: ' + e.message);
        return;
    }
    loadCategoryManagement();
    loadCategoryFilter();
}



// window bridges for template onclick handlers
window.addCategoryInline = addCategoryInline;
window.showProductForm = showProductForm;
window.closeProductForm = closeProductForm;
window.submitProductForm = submitProductForm;

window.deleteCategory = deleteCategory;
window.deleteProduct = deleteProduct;
window.saveCategoryInline = saveCategoryInline;
window.filterProductTable = filterProductTable;
export { initProductCenter, loadProducts, loadCategoryFilter, loadCategoryManagement, updateAllProductRateDisplays };
